
export const getRemainingListingTime = (startTime: string) => {

    let seconds = parseInt(startTime) - new Date().getTime() / 1000;
    var days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    var hrs = Math.floor(seconds / 3600);
    seconds -= hrs * 3600;
    var mnts = Math.floor(seconds / 60);
    seconds -= mnts * 60;
    return {days, hrs, mnts, seconds};
}

export const getRemainingLaunchTime = () => {
  const start_time = "1667851200" // Nov 7 Noon
  let seconds = parseInt(start_time) - new Date().getTime() / 1000;
  var days = Math.floor(seconds / (3600 * 24));
  seconds -= days * 3600 * 24;
  var hrs = Math.floor(seconds / 3600);
  seconds -= hrs * 3600;
  var mnts = Math.floor(seconds / 60);
  seconds -= mnts * 60;
  seconds = Math.floor(seconds)
  return {days, hrs, mnts, seconds};
}



export const getRemainingDays = (startTime: string) => {

    const {days} = getRemainingListingTime(startTime);

    if (days === 0) {
      return [0, 0, 0];
    } else {
      let array = days.toString().split("");
      if (array.length < 3) {
        const numOfDigits = array.length;
        for (let i = 0; i < 3 - numOfDigits; i++) {
          array = ["0"].concat(array);
        }
      }
      return array;
    }
  };

  export const getRemainingMinutes = (startTime: string) => {
    const {mnts} = getRemainingListingTime(startTime);
    if (mnts === 0) {
      return [0, 0];
    } else {
      let array = mnts.toString().split("");
      if (array.length < 2) {
        const numOfDigits = array.length;
        for (let i = 0; i < 2 - numOfDigits; i++) {
          array = ["0"].concat(array);
        }
      }
      return array;
    }
  };

  export const getRemainingHours = (startTime: string) => {
    const {hrs} = getRemainingListingTime(startTime);    
    if (hrs === 0) {
      return [0, 0];
    } else {
      let array = hrs.toString().split("");
      if (array.length < 2) {
        const numOfDigits = array.length;
        for (let i = 0; i < 2 - numOfDigits; i++) {
          array = ["0"].concat(array);
        }
      }
      return array;
    }
  };
  export const getRemainingLaunchDays = () => {
    const {days} = getRemainingLaunchTime();
    return days
  };

  export const getRemainingLaunchHours = () => {
    const {hrs} = getRemainingLaunchTime();    
      return hrs;
  };
  export const getRemainingLaunchMinutes = () => {
    const {mnts} = getRemainingLaunchTime();
      return mnts;
  };

  export const getRemainingLaunchSeconds = () => {
    const {seconds} = getRemainingLaunchTime();    
      return seconds;
  };
